<template>
  <div class="agreement-page">
    <div class="agreement-container">
      <div class="back-bar">
        <span class="back-link" @click="goBack">&lt; 返回</span>
      </div>
      <h1 class="agreement-title">博览财经资讯库网页端个人用户服务协议（电子签约版）</h1>

      <h3 class="section-title">特别提示</h3>
      <p>本协议为<b>电子格式合同</b>，乙方已采取加粗、专项提示等合理方式提请您重点关注免除或限制乙方责任、争议管辖、退款规则、风险提示等与您有重大利害关系的条款。请您在签约前完整阅读全部内容，如有疑问可通过乙方客服渠道咨询。您点击「同意并购买」按钮即视为您已充分阅读、理解并接受本协议全部条款，本协议立即对双方产生法律约束力。</p>
      <p>本服务仅提供金融资讯整合、加工与查阅服务，<b>不构成任何证券、基金、期货等金融产品的投资建议、买卖推荐或收益承诺，不属于证券投资咨询服务。</b>市场有风险，投资需谨慎，您基于资讯内容作出的所有投资决策及相应损失，均由您自行承担。</p>
      <p>本服务属于数字化在线服务，<b>一经开通交付，不适用七日无理由退货规则</b>，请您确认需求后再完成支付。</p>

      <h3 class="section-title">第一条 协议主体与定义</h3>
      <p><b>甲方（用户）</b>：指通过乙方资讯库网站注册账号、购买并使用本服务的自然人。</p>
      <p><b>乙方</b>：武汉博览财经信息技术股份有限公司，具备中华人民共和国增值电信业务经营许可证（证书编号：鄂 B2-20260505），合法提供互联网金融信息服务。</p>
      <p><b>服务</b>：指乙方通过其官方资讯库网页端，向甲方提供的金融资讯、市场数据、研报整合、行业分析等在线查阅服务，具体服务范围以甲方下单时所选套餐对应的栏目为准。</p>
      <p><b>账号</b>：指甲方注册并用于登录、使用本服务的个人账户，仅限甲方本人使用。</p>
      <p><b>工作日</b>：指国家法定节假日之外的自然日，不含周六、周日及法定节假日。</p>
      <p><b>不可抗力</b>：指合同双方不能合理控制、不可预见或即使预见亦无法避免的事件，包括但不限于政府行为、自然灾害、战争、网络基础设施大面积故障、监管政策重大调整等。</p>

      <h3 class="section-title">第二条 服务内容与服务期限</h3>
      <p>1. 乙方通过网页端向甲方提供对应套餐的金融资讯查阅服务，服务内容、栏目范围以甲方下单页面公示的信息为准。</p>
      <p>2. 服务期限自甲方支付成功、服务自动开通之日起计算，至所选套餐约定的服务周期届满之日止，具体时长以订单详情为准。</p>
      <p>3. 乙方有权根据监管要求、业务优化需要对服务栏目、内容进行合理调整，调整前将通过网站公告提前7日公示；调整未实质降低服务价值的，不构成违约。</p>

      <h3 class="section-title">第三条 费用与支付</h3>
      <p>1. 服务费用以甲方下单时页面公示的含税价格为准，价格一经支付完成，除本协议约定的可退款情形外，不予调整。</p>
      <p>2. <b>支付方式</b>：甲方可通过支付宝扫码、微信扫码等线上支付方式完成付款。支付成功后系统自动开通服务权限，甲方可通过账号登录使用。</p>
      <p>3. 订单提交后请在24小时内完成支付，逾期未支付的订单将自动取消。</p>
      <p>4. <b>发票说明</b>：甲方如需开具发票，可在个人中心提交开票申请，乙方将在收到申请后10个工作日内开具增值税电子普通发票，并发送至甲方预留的电子邮箱。</p>
      
      <h3 class="section-title">第四条 双方权利与义务</h3>
      <p class="sub-heading">（一）甲方权利与义务</p>
      <p>1. 有权在服务期限内，按照本协议约定个人使用本服务，查阅对应权限范围内的资讯内容。</p>
      <p>2. 自行配备上网所需的终端设备、网络环境，并自行承担相关设备及通信费用。</p>
      <p>3. 保证注册信息真实、准确、有效，个人信息变更时及时更新；因信息不实导致的服务中断、账号损失及法律责任，由甲方自行承担。</p>
      <p>4. 妥善保管账号及密码，对账号下的所有操作和行为承担全部责任。不得将账号转借、出租、售卖、共享给任何第三方，不得通过技术手段突破同时登录设备限制。如发现账号被盗用或异常登录，应立即通知乙方。</p>
      <p>5. 仅可出于<b>个人非商业目的</b>使用本服务及资讯内容，不得实施下列行为：</p>
      <p class="indent">（1）复制、转载、传播、发布乙方资讯内容至任何公开平台、社群或第三方；</p>
      <p class="indent">（2）对资讯内容进行二次加工、售卖牟利、商用演示等经营性使用；</p>
      <p class="indent">（3）通过爬虫、数据抓取、反向工程、反向编译、破解验证等手段非法获取乙方服务数据、系统源代码；</p>
      <p class="indent">（4）利用本服务从事违反证券期货监管规定、扰乱市场秩序或其他违法违规活动；</p>
      <p class="indent">（5）其他侵犯乙方知识产权或损害乙方合法权益的行为。</p>
      <p>6. 如需公开引用乙方资讯内容，需注明「来源：博览财经」，且不得歪曲、篡改内容原意。</p>
      <p class="sub-heading">（二）乙方权利与义务</p>
      <p>1. 按照协议约定向甲方提供对应权限的资讯服务，保障服务系统的正常运行。</p>
      <p>2. 保证所提供的资讯内容系合法整合加工，因资讯内容版权纠纷给甲方造成直接损失的，由乙方承担相应责任。</p>
      <p>3. 遇网络故障、系统维护等情况导致服务中断的，应及时通过网站公告或站内信通知甲方，并尽快恢复服务；非计划性服务中断连续超过24小时的，乙方将按中断时长相应顺延甲方的服务期限。</p>
      <p>4. 有权对服务系统进行升级、优化，升级期间尽量减少对甲方正常使用的影响；计划性停机维护将提前3日通过网站公告通知。</p>
      <p>5. 设立客服服务渠道（客服电话：13396040230（赵女士微信同号）；客服邮箱：bolancaijing@bolanjr.com），为甲方提供服务咨询与问题反馈。</p>
      <p>6. 按照《中华人民共和国个人信息保护法》及网站公示的《隐私政策》处理甲方个人信息。</p>
      <p>7. 对甲方的违规使用行为，有权视情节轻重采取警告、限制功能、暂停服务、永久封禁账号等措施，且不予退还剩余服务费用；造成乙方损失的，有权向甲方追偿。</p>

      <h3 class="section-title">第五条 知识产权</h3>
      <p>1. 乙方对本服务所包含的所有资讯内容、页面设计、商标、标识、系统程序、数据汇编成果等均享有完整的知识产权或合法授权。</p>
      <p>2. 甲方仅获得本服务的个人非独占、不可转让、不可转授权的使用权，未获得任何知识产权的权属授权。</p>
      <p>3. 甲方违反本协议约定侵犯乙方知识产权的，乙方有权要求甲方立即停止侵权行为、消除影响，并赔偿乙方因此遭受的全部损失（包括但不限于维权费用、商誉损失、经济损失）。</p>

      <h3 class="section-title">第六条 个人信息保护</h3>
      <p>1. 乙方严格遵守个人信息保护相关法律法规，遵循合法、正当、必要原则处理甲方个人信息。</p>
      <p>2. 甲方可通过网站《隐私政策》页面，详细了解乙方个人信息处理规则，包括信息收集范围、使用目的、存储期限、甲方享有的信息权利及行权方式等。</p>
      <p>3. 甲方同意乙方为履行本协议、保障服务安全、优化服务体验之必要，收集、使用甲方的注册信息、支付信息、服务使用日志等必要信息。</p>

      <h3 class="section-title">第七条 免责与风险提示</h3>
      <p>1. <b>投资风险免责</b>：本服务所有资讯数据内容仅为市场信息整合与参考，不构成任何投资决策依据，不承诺任何投资收益。甲方应结合自身风险承受能力独立作出投资判断，自行承担全部投资风险与损失，乙方不对甲方的投资决策结果承担任何直接或间接责任。</p>
      <p>2. <b>信息来源免责</b>：乙方对资讯内容中引用的公开信息、第三方原始数据的真实性、准确性、完整性不作担保，仅对自身整合加工的分析结论负责跟踪与修正。甲方应自行甄别信息的有效性与适用性。</p>
      <p>3. <b>服务稳定性免责</b>：因下列原因导致服务中断、延迟、数据异常或无法使用的，乙方不承担违约责任：</p> 
      <p class="indent">（1）不可抗力事件；</p>
      <p class="indent">（2）互联网主干线路故障、电信运营商技术调整、黑客攻击、计算机病毒入侵、系统非乙方可控的安全漏洞等技术风险；</p>
      <p class="indent">（3）甲方自身设备故障、网络中断、操作失误、账号泄露或被盗用等自身原因；</p>
      <p class="indent">（4）为配合监管要求、合规整改进行的服务调整。</p>
      <p>4. <b>政策调整免责</b>：因国家法律法规、监管政策重大调整，导致乙方需变更、暂停或终止全部/部分服务的，乙方不承担违约责任，将按甲方剩余未使用服务时长折算退还相应费用。</p>
      <p>5. 乙方仅对本协议约定范围内的直接损失承担责任，不对甲方的预期利益损失、间接损失、商业机会损失等承担责任。</p>

      <h3 class="section-title">第八条 违约责任</h3>
      <p>1. 若甲方违反本协议约定（包括但不限于违规共享账号、侵权传播资讯内容、利用服务从事违法活动等），乙方有权视情节采取警告、限制服务功能、暂停服务直至永久封禁账号的处置措施，已收取的服务费用不予退还；给乙方造成损失的，甲方应全额赔偿。</p>
      <p>2. 若乙方无正当理由中断服务，且未按约定顺延服务期限，连续超过3个工作日的，甲方有权申请解除协议，乙方应按剩余未使用服务时长折算退还相应费用，并支付剩余费用10%的违约金。</p>
      <p>3. 因甲方自身操作失误、账号保管不当导致无法使用服务的，乙方不承担责任，不予退还服务费用。</p>

      <h3 class="section-title">第九条 协议的变更、解除与终止</h3>
      <p>1. <b>协议变更</b>：乙方有权根据法律法规更新、监管政策要求或业务优化需要修订本协议。修订后的协议将在网站显著位置公示，公示期为7日。公示期满后，甲方继续使用本服务的，视为接受修订后的协议；甲方不接受修订内容的，可申请注销账号并按剩余时长申请退费。</p>
      <p>2. <b>协议解除</b>：</p>
      <p class="indent">（1）双方协商一致，可以解除本协议。</p>
      <p class="indent">（2）甲方严重违反本协议约定的，乙方有权单方解除协议，终止服务，不予退费。</p>
      <p class="indent">（3）乙方严重违约导致甲方无法正常使用服务的，甲方有权单方解除协议，乙方按本协议约定退还剩余费用。</p>
      <p>3. <b>协议终止</b>：</p>
      <p class="indent">（1）服务期限届满，本协议自动终止，服务权限同步关闭。</p>
      <p class="indent">（2）双方解除协议的，协议自解除之日终止。</p>
      <p class="indent">（3）因不可抗力、政策调整导致服务无法继续提供的，协议终止，乙方退还甲方剩余未使用部分的对应费用。</p>
      <p>4. <b>退款规则</b>：</p>
      <p class="indent">（1）服务开通前，甲方可申请全额退款。</p>
      <p class="indent">（2）服务开通后，非因乙方违约原因甲方申请解除协议的，不予退还已支付的服务费用。</p>
      <p class="indent">（3）因乙方违约、政策调整等原因终止服务的，按「剩余未使用天数÷服务总天数×已付费用」折算退还。</p>

      <h3 class="section-title">第十条 争议解决</h3>
      <p>因本协议引起的或与本协议有关的任何争议，双方应首先通过友好协商解决；协商不成的，任何一方均有权向<b>乙方住所地有管辖权的人民法院</b>提起诉讼。</p>

      <h3 class="section-title">第十一条 其他条款</h3>
      <p>1. 本协议包括正文及网站公示的《隐私政策》等相关附件，均为本协议不可分割的组成部分，具有同等法律效力。</p>
      <p>2. 本协议自甲方点击「同意并购买」并完成支付之日起生效。</p>
      <p>3. 若本协议中的任何条款被有权机关认定为无效或不可执行，不影响其他条款的法律效力。</p>
      <p>4. 乙方未行使本协议项下的任何权利，不视为对该权利的放弃。</p>
      <p>5. 甲方确认自身为具有完全民事行为能力的自然人；若甲方为未成年人，应在监护人陪同下阅读本协议，并在监护人同意后使用本服务。</p>
      <p>6. 所有通知均可通过网站公告、站内信、甲方预留邮箱等方式送达；公告发布之日或邮件发送之日即视为有效送达。</p>

      <h3 class="section-title">乙方信息</h3>
      <p>名称：武汉博览财经信息技术股份有限公司</p>
      <p>地址：湖北省武汉市东湖新技术开发区光谷大道光谷芯中心文华楼3单元605</p>
      <p>客服电话：13396040230（赵女士微信同号）</p>
      <p>客服邮箱：bolancaijing@bolanjr.com</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Agreement',
  created() {
    this.$emit('header', true);
    this.$emit('footer', true);
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push('/');
      }
    }
  }
}
</script>

<style scoped>
.agreement-page {
  background-color: #f5f7fa;
  min-height: 100vh;
  padding-bottom: 40px;
}
.agreement-container {
  width: 1200px;
  max-width: 1200px;
  margin: 70px auto 0;
  background-color: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  padding: 40px 60px 60px;
  box-sizing: border-box;
}
.back-bar {
  margin-bottom: 20px;
}
.back-link {
  color: #409eff;
  font-size: 14px;
  cursor: pointer;
}
.back-link:hover {
  color: #66b1ff;
}
.agreement-title {
  font-size: 24px;
  font-weight: 600;
  color: #303133;
  text-align: center;
  margin: 10px 0 30px;
  line-height: 1.5;
}
.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin: 28px 0 14px;
  padding-left: 10px;
  border-left: 4px solid #c0a36c;
}
.agreement-container p {
  font-size: 15px;
  line-height: 1.9;
  color: #333333;
  margin: 8px 0;
  text-align: justify;
}
.agreement-container p.sub-heading {
  font-weight: 600;
  color: #303133;
  margin-top: 14px;
}
.agreement-container p.indent {
  padding-left: 32px;
}
.agreement-container b {
  font-weight: 700;
  color: #303133;
}
</style>



// WEBPACK FOOTER //
// src/components/Agreement.vue